import { useState } from "react";

import LinkedInLogo from "../LogoSVG/LinkedInLogo";
import TelegramLogo from "../LogoSVG/TelegramLogo";
import GithubLogo from "../LogoSVG/GithubLogo";
import LeetcodeLogo from "../LogoSVG/LeetcodeLogo";
import EmailLogo from "../LogoSVG/EmailLogo";
import ConnectDesktopItem from "./ConnectDesktopItem";

function ConnectDesktop() {
  const [hoveredIndex, setHoveredIndex] = useState<number>();

  return (
    <section id="connect" className="mb-32 mt-28">
      <div className="container items-start flex flex-row">
        <div className="flex flex-row items-center">
          <p className="text-[24px] font-medium">Connect</p>
        </div>

        <div className="ml-28">
          <div
            className="flex flex-row"
            onMouseEnter={() => setHoveredIndex(6)}
            onMouseLeave={() => setHoveredIndex(undefined)}
          >
            <ConnectDesktopItem
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              Logo={GithubLogo}
              url="https://github.com/lnqminh3003"
              index={1}
              nameLogo="Github"
              className="mb-2"
            />

            <ConnectDesktopItem
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              Logo={LeetcodeLogo}
              url="https://leetcode.com/u/minhle3003/"
              index={2}
              nameLogo="Leetcode"
              className="mb-2"
            />
          </div>

          <div
            className="flex flex-row"
            onMouseEnter={() => setHoveredIndex(6)}
            onMouseLeave={() => setHoveredIndex(undefined)}
          >
            <ConnectDesktopItem
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              Logo={LinkedInLogo}
              url="https://www.linkedin.com/in/minhle3003/"
              index={3}
              nameLogo="LinkedIn"
              className="mt-1"
            />

            <ConnectDesktopItem
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              Logo={TelegramLogo}
              url="https://t.me/minhle3003"
              index={4}
              nameLogo="Telegram"
              className="mt-1"
            />
          </div>

          <div
            className={`flex flex-start items-center ${
              hoveredIndex == undefined || hoveredIndex == 5 ? "" : "opacity-55"
            }`}
            onMouseEnter={() => setHoveredIndex(5)}
            onMouseLeave={() => setHoveredIndex(undefined)}
          >
            <div
              className="w-[496px] mt-3 bg-gray-2  hover:scale-[1.05] transition-all duration-350
                flex flex-row  items-center p-4 rounded-lg"
            >
              <a
                className="flex flex-row items-center justify-around w-full"
                href="mailto:lnqminh3003@gmail.com"
              >
                <div className="flex flex-row items-center">
                  <EmailLogo />
                  <p className="ml-3.5 text-[17px] leading-7">Collaborations</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ConnectDesktop;
